import { DayHeading, DaySection } from "./day";

const faqs = [
  {
    q: "How is this different from ChatGPT?",
    a: "A chatbot answers one question at a time and forgets. LearnAnything turns where you’re going into a course: short lessons in the right order, each building on the last, that remember what you already know.",
  },
  {
    q: "Can I trust what it teaches?",
    a: "Where it matters, lessons are built from real sources and key claims link to them. In fast-moving fields it tells you what’s proven and what’s still promising. If new research changes something you’ve learned, it tells you. When it isn’t sure, it says so.",
  },
  {
    q: "What if I don’t know where to start?",
    a: "That’s fine. Type whatever’s on your mind, even if it’s vague. It asks only what it needs, usually one or two questions, then gets you started.",
  },
  {
    q: "How much time does it take?",
    a: "A lesson takes a few minutes. Do one on a coffee break or a few in a row. Your course waits where you left it.",
  },
  {
    q: "Will it quiz me?",
    a: "Not right after you learn something. Lessons are for taking ideas in. Already know it? Tap “I know this” and skip ahead.",
  },
  {
    q: "Is there an app?",
    a: "Yes. Start on the web today. The iPhone and Android apps are coming soon, and your courses will be on both.",
  },
  {
    q: "What does Pro cost?",
    a: "Pro starts with a free trial, so you can try a full course first. You’ll see the price before the trial begins, and you can cancel any time.",
  },
];

export function Faq() {
  return (
    <DaySection id="faq" label="FAQ">
      <div className="grid gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-12">
        <DayHeading eyebrow="FAQ" title="Questions people ask." />
        <div className="flex flex-col gap-3">
          {faqs.map(f => (
            <details key={f.q} className="group rounded-[20px] border-2 border-b-[5px] border-[#E7E3F0] bg-white px-5 py-4 sm:px-6 [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-[17px] font-extrabold text-[#1C1A27] sm:text-lg">
                {f.q}
                <span className="grid size-7 shrink-0 place-items-center rounded-full bg-[#EFEAFF] text-lg font-black text-[#6B4EFF] transition group-open:rotate-45">+</span>
              </summary>
              <p className="mt-3 leading-relaxed text-[#6B6780]">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </DaySection>
  );
}
